import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      padding: spacing.m,
      backgroundColor: theme.modal.background,
      borderRadius: constants.radius.card,
      width: "90vw",
      maxWidth: 700,
    },
    disclaimer: {
      paddingLeft: spacing.xs,
      paddingRight: spacing.xs,
    },
    link: {
      fontSize: 10,
      color: theme.link.secondary,
    },
    input: {
      all: "unset",
      textAlign: "right",
      color: theme.input.text,
    },
    divider: {
      width: constants.divPadding,
    },
    secondary: {
      backgroundColor: theme.modal.button.secondary,
    },
  };

  return styles;
};
